import { api_GET_External, api_POST, api_POST_Unauthorize } from "./_api.js";
import bairro_api from "./bairro_api.js";

const cep_api =
{
    get: function (cep) {
        const promise = new Promise((resolve, reject) => {
            api_GET_External(`https://viacep.com.br/ws/${cep.replace("-", "")}/json/`).then(result => {
                if (result.data.erro)
                    reject({ message: "CEP não encontrado" });

                bairro_api.GetItemByBairro(result.data.bairro).then(response => {
                    if (response.data)
                        result.data.setor_Id = response.data.setor_Id;

                    resolve(result);
                }).catch(e => {
                    resolve(result);
                });

            }).catch(e => {
                reject(e);
            });
        });

        return promise;
    },
    GeoCode: function (endereco) {
        const promise = new Promise((resolve, reject) => {
            api_POST_Unauthorize("GeoCode", endereco)
                .then(result => resolve(result))
                .catch(e => reject(e));
        })
        return promise;
    }

}

export default cep_api
